export const TIER_ORDER_EASY_TO_HARD = [
  'tier_6',
  'tier_5',
  'tier_4',
  'tier_3',
  'tier_2',
  'tier_1',
];

export const DEFAULT_TIER = 'tier_6';

export const TIER_INFO = Object.freeze({
  tier_6: {
    studentLabel: 'Foundation',
    studentDescription: 'Chinese-supported contexts',
    teacherLabel: 'Building confidence',
    teacherDescription: 'Benefits from familiar contexts and guided support.',
  },
  tier_5: {
    studentLabel: 'Starter',
    studentDescription: 'Simple English clues',
    teacherLabel: 'Finding their footing',
    teacherDescription: 'Ready to learn new words through clear, familiar English.',
  },
  tier_4: {
    studentLabel: 'Bridge',
    studentDescription: 'Clear everyday English',
    teacherLabel: 'Finding momentum',
    teacherDescription: 'Ready to build fluency through junior-high reading contexts.',
  },
  tier_3: {
    studentLabel: 'Core',
    studentDescription: 'Richer real-world English',
    teacherLabel: 'Growing steadily',
    teacherDescription: 'Developing confidence with senior-high and early CET material.',
  },
  tier_2: {
    studentLabel: 'Advanced',
    studentDescription: 'Academic reading practice',
    teacherLabel: 'Advancing strongly',
    teacherDescription: 'Ready for DSE and TOEFL-style language and structure.',
  },
  tier_1: {
    studentLabel: 'Challenge',
    studentDescription: 'SAT-style depth',
    teacherLabel: 'Ready to excel',
    teacherDescription: 'Thrives on the most demanding vocabulary and reasoning tasks.',
  },
});

export const localizeTierInfo = (tier, t = (value) => value) => {
  const info = getTierInfo(tier);
  return Object.fromEntries(Object.entries(info).map(([key, value]) => [key, t(value)]));
};

export const getTierInfo = (tier) => TIER_INFO[tier] || TIER_INFO[DEFAULT_TIER];

export const getAvailableTiers = (assignedTier) => {
  const normalized = TIER_INFO[assignedTier] ? assignedTier : DEFAULT_TIER;
  const start = TIER_ORDER_EASY_TO_HARD.indexOf(normalized);
  return TIER_ORDER_EASY_TO_HARD.slice(start);
};
